export enum AnalyticEvent
{
	PAGE_VIEW= "public_page_view",
}
